var render, staticRenderFns
import script from "./Pill.vue?vue&type=script&lang=ts&"
export * from "./Pill.vue?vue&type=script&lang=ts&"
import style0 from "./Pill.vue?vue&type=style&index=0&id=145c5528&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports